// Apolo IDE — Cursor-style agent TODO list (sprint code-chat-cursor-parity, E5).
//
// The "N Tasks" checklist Cursor shows while the agent works: each step is a row
// with a status glyph (pending ○ / in-progress spinner / done ✓) and the count.
// Pure: driven by the `todos` prop so it's unit-testable; the in-progress spinner
// + accent use the Cursor orange via the .rx-shell-scoped apolo-accent override.

import { Check, Circle, LoaderCircle } from 'lucide-react';

function normalizeStatus(s) {
  const v = String(s || 'pending').toLowerCase();
  if (v === 'done' || v === 'completed' || v === 'complete') return 'done';
  if (v === 'in_progress' || v === 'doing' || v === 'running' || v === 'active') return 'in_progress';
  return 'pending';
}

export default function AgentTodoList({ todos = [], title }) {
  if (!Array.isArray(todos) || todos.length === 0) return null;
  const done = todos.filter((t) => normalizeStatus(t?.status) === 'done').length;

  return (
    <div
      className="rounded-xl border border-apolo-borderSubtle bg-apolo-surface1/70 px-3 py-2.5"
      data-testid="agent-todo-list"
      aria-label="Lista de tarefas do agente"
    >
      <div className="mb-1.5 flex items-center justify-between">
        <span className="text-[11px] font-semibold uppercase tracking-wider text-apolo-textTertiary">
          {title || `${todos.length} ${todos.length === 1 ? 'Task' : 'Tasks'}`}
        </span>
        <span
          role="status"
          aria-live="polite"
          className="font-mono text-[10px] text-apolo-textTertiary"
          data-testid="agent-todo-count"
          aria-label={`${done} de ${todos.length} tarefas concluídas`}
        >
          {done}/{todos.length}
        </span>
      </div>
      <ul className="flex flex-col gap-0.5">
        {todos.map((t, i) => {
          const status = normalizeStatus(t?.status);
          const Icon = status === 'done' ? Check : status === 'in_progress' ? LoaderCircle : Circle;
          const iconCls =
            status === 'done'
              ? 'text-apolo-success'
              : status === 'in_progress'
                ? 'text-apolo-accent animate-spin'
                : 'text-apolo-textTertiary';
          const textCls =
            status === 'done'
              ? 'text-apolo-textTertiary line-through'
              : status === 'in_progress'
                ? 'text-apolo-textPrimary'
                : 'text-apolo-textSecondary';
          return (
            <li
              key={t?.id ?? i}
              className="flex items-start gap-2 py-0.5 text-[13px]"
              data-status={status}
              aria-label={`Tarefa ${status === 'done' ? 'concluída' : status === 'in_progress' ? 'em andamento' : 'pendente'}: ${t?.text ?? t?.title ?? t?.label ?? ''}`}
            >
              <Icon size={13} className={`mt-0.5 shrink-0 ${iconCls}`} aria-hidden="true" />
              <span className={textCls}>{t?.text ?? t?.title ?? t?.label ?? ''}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
